import { defineMessages } from 'react-intl'

export default defineMessages({
  logIn: {
    id: 'Header.menuBar.logIn',
    defaultMessage: 'Log in',
  },
  noAccount: {
    id: 'Redeem.login.notAUser',
    defaultMessage: 'Not a Lifesum user?',
  },
  alreadyHave: {
    id: 'SignUp.alreadyHave',
    defaultMessage: 'Already have an account?',
  },
  signUp: {
    id: 'SignUp.signUp',
    defaultMessage: 'Sign up',
  },
  physicalDetails: {
    id: 'SignUp.physicalDetails',
    defaultMessage: 'Physical details',
  },
  accountDetails: {
    id: 'SignUp.accountDetails',
    defaultMessage: 'Account details',
  },
  yourGoal: {
    id: 'SignUp.yourGoal',
    defaultMessage: 'How can we help you?',
  },
  goal_lose: {
    id: 'goal_lose',
    defaultMessage: 'Lose weight',
  },
  goal_lose_sub: {
    id: 'goal_lose_sub',
    defaultMessage: 'Manage your weight by eating smarter',
  },
  goal_maintain: {
    id: 'goal_maintain',
    defaultMessage: 'Maintain weight',
  },
  goal_maintain_sub: {
    id: 'goal_maintain_sub',
    defaultMessage: 'Optimize your well-being',
  },
  goal_gain: {
    id: 'goal_gain',
    defaultMessage: 'Gain weight',
  },
  goal_gain_sub: {
    id: 'goal_gain_sub',
    defaultMessage: 'Build strength with high-protein food',
  },
  female: {
    id: 'SignUp.female',
    defaultMessage: 'Female',
  },
  male: {
    id: 'SignUp.male',
    defaultMessage: 'Male',
  },
  hi: {
    id: 'SignUp.hi',
    defaultMessage: 'Alright!',
  },
  basics: {
    id: 'SignUp.basics',
    defaultMessage: 'Let’s get the basics down first.',
  },
  yourAge: {
    id: 'SignUp.yourAge',
    defaultMessage: 'Your age',
  },
  yourHeight: {
    id: 'SignUp.yourHeight',
    defaultMessage: 'Your height',
  },
  yourWeight: {
    id: 'SignUp.yourWeight',
    defaultMessage: 'Your weight',
  },
  goalWeight: {
    id: 'SignUp.goalWeight',
    defaultMessage: 'Goal weight',
  },
  iPrefer: {
    id: 'SignUp.iPrefer',
    defaultMessage: 'I prefer',
  },
  next: {
    id: 'SignUp.next',
    defaultMessage: 'Next',
  },
  greeting: {
    id: 'UserAccount_Dashboard_MainHeading',
    defaultMessage: 'Hi!',
  },
  youNeedToBe13: {
    id: 'SignUp.youNeedToBe13',
    defaultMessage: '13 or above, please. (Age is just a number, right?)',
  },
  genericError: {
    id: 'SignUp.genericError',
    defaultMessage: 'Please make sure you entered everything correctly.',
  },
  years: {
    id: 'SignUp.years',
    defaultMessage: 'years',
  },
  firstName: {
    id: 'SignUp.firstName',
    defaultMessage: 'First name',
  },
  lastName: {
    id: 'SignUp.lastName',
    defaultMessage: 'Last name',
  },
  email: {
    id: 'SignUp.email',
    defaultMessage: 'Email',
  },
  password: {
    id: 'Redeem.login.password',
    defaultMessage: 'Password',
  },
  passwordHint: {
    id: 'SignUp.passwordHint',
    defaultMessage: 'min. 8 characters',
  },
  change: {
    id: 'SignUp.change',
    defaultMessage: 'Change',
  },
  country: {
    id: 'SignUp.country',
    defaultMessage: 'Country',
  },
  months: {
    id: 'Redeem.plans.months',
    defaultMessage: 'months',
  },
  month: {
    id: 'Redeem.plans.month',
    defaultMessage: 'month',
  },
  free: {
    id: 'PremiumPage.freeText',
    defaultMessage: 'Free',
  },
  chooseAPlan: {
    id: 'upgrade.plan_heading',
    defaultMessage: 'Choose your subscription',
  },
  compareFeatures: {
    id: 'SignUp.compareFeatures',
    defaultMessage: 'Compare features',
  },
  gettingYouSetUp: {
    id: 'SignUp.gettingYouSetUp',
    defaultMessage: 'Great, we’re getting you all set up!',
  },
  logInHere: {
    id: 'SignUp.logInHere',
    defaultMessage: 'Log in here',
  },
  optimize: {
    id: 'SignUp.optimize',
    defaultMessage:
      'This information will help us to optimize your experience.',
  },
  weKnow: {
    id: 'SignUp.weKnow',
    defaultMessage:
      'We know, it’s a little old timey, but this helps us make the app work better for you.',
  },
  shortMon: {
    id: 'SignUp.shortMon',
    defaultMessage: 'mon',
  },
  SubWillRenew: {
    id: 'SignUp.SubWillRenew',
    defaultMessage: 'Subscription will renew automatically if not cancelled.',
  },
  finePrint: {
    id: 'Redeem.plans.finePrint',
    defaultMessage:
      'You will be charged the total amount for the subscription period at once (monthly price × duration of subscription). Lifesum Premium automatically renews at the end of its duration unless you turn it off.',
  },
  policyAgreement: {
    id: 'policy_agreement',
    defaultMessage:
      'By continuing, you agree to Lifesum’s <a>Terms of Service & Privacy Policy</a>.',
  },
  goalWeightBelow: {
    id: 'SignUp.goalWeightBelow',
    defaultMessage:
      'Please set your goal weight below your current weight, or go back and update your overall goal.',
  },
  goalWeightAbove: {
    id: 'SignUp.goalWeightAbove',
    defaultMessage:
      'Please set your goal weight above your current weight, or go back and update your overall goal.',
  },
  welcomeTo: {
    id: 'SignUp.welcomeTo',
    defaultMessage: 'Welcome to',
  },
  welcomeText: {
    id: 'SignUp.welcomeText',
    defaultMessage:
      'Alright, you’re good to go. Since we’re just so 2018 though, you’ll need to download our app to get going. See you there homie!',
  },
  codeApplied: {
    id: 'SignUp.codeApplied',
    defaultMessage: 'Code applied!',
  },
  continueToClaim: {
    id: 'SignUp.continueToClaim',
    defaultMessage: 'Continue to claim your <b>{percentage}</b> discount',
  },
  expiredMessage: {
    id: 'Redeem.start.expiredMessage',
    defaultMessage: 'We’re sorry but the code has expired.',
  },
  invalidMessage: {
    id: 'Signup.invalidCode',
    defaultMessage: 'Sorry, the code is invalid.',
  },
  continueWithEmail: {
    id: 'Signup.continueWithEmail',
    defaultMessage: 'Continue with e-mail',
  },
  continueWithFacebook: {
    id: 'Redeem.login.continueWithFacebook',
    defaultMessage: 'Continue with Facebook',
  },
  dontWorry: {
    id: 'Redeem.login.dontWorry',
    defaultMessage:
      'Don’t worry, we’ll never share anything without your permission.',
  },
  signup_page_complete_message1: {
    id: 'signup_page_complete_message1',
    defaultMessage:
      "You've taken the first step towards a healthier you. Now all you have to do is download the Lifesum app from {appStore} or {googlePlay}, and you're good to go.\n\n",
  },
  signup_page_complete_title2: {
    id: 'signup_page_complete_title2',
    defaultMessage: 'Improve your chances of reaching your health goals',
  },
  signup_page_complete_message2: {
    id: 'signup_page_complete_message2',
    defaultMessage:
      'Here are a few good tools to help you get started on your health journey.',
  },
  creditCardInformation: {
    id: 'Redeem.pay.creditCardInformation',
    defaultMessage: 'Bank card details',
  },
  'Footer.TOSandPrivacyPolicy': {
    id: 'Footer.TOSandPrivacyPolicy',
    defaultMessage: 'Terms of Service & Privacy Policy',
  },
  'upgrade.pay_heading': {
    id: 'upgrade.pay_heading',
    defaultMessage: 'Set up your payment',
  },
  'upgrade.pay_heading_trial': {
    id: 'upgrade.pay_heading_trial',
    defaultMessage: 'Start your {days}-day free trial',
  },
  feature_table_heading: {
    id: 'UserAccount_ManageSubscriptionFree_PremiumBox_IntroText',
    defaultMessage:
      'Full access to the tools you need to crush your health goals',
  },
  feature_1: {
    id: 'UserAccount_PremiumTable_MealPlansFeature',
    defaultMessage: 'Meal Plans & shopping list (e.g. Keto, Vegan)',
  },
  feature_2: {
    id: 'homepage_teaser_macro_net_carb_tracking_header',
    defaultMessage: 'Macro & Net Carb Tracking\n',
  },
  feature_3: {
    id: 'UserAccount_PremiumTable_LifeScoreFeature',
    defaultMessage: 'Weekly Life Score™',
  },
  feature_4: {
    id: 'UserAccount_PremiumTable_RecipeFeature',
    defaultMessage: 'Recipe library',
  },
  feature_5: {
    id: 'homepage_teaser_sync_with_health_apps_header',
    defaultMessage: 'Easy Sync with Health Apps',
  },
  errorEmailAlreadyConnected: {
    id: 'errorEmailAlreadyConnected',
    defaultMessage: 'This email is already connected to a Lifesum account.',
  },
  errorEmailMalformed: {
    id: 'errorEmailMalformed',
    defaultMessage: 'Are you sure you entered your email address correctly?',
  },
  errorFacebookAlreadyConnected: {
    id: 'errorFacebookAlreadyConnected',
    defaultMessage:
      'The email your Facebook account is associated with is already connected to a Lifesum account.',
  },
  errorFacebookWentWrong: {
    id: 'errorFacebookWentWrong',
    defaultMessage:
      'Something went wrong when trying to connect to your Facebook account. Please try again!',
  },
  allCountries: {
    id: 'allCountries',
    defaultMessage: 'All countries',
  },
  whatYouGet: {
    id: 'redeem_page_usp_title',
    defaultMessage: 'What you get',
  },
  success_stories: {
    id: 'success_stories',
    defaultMessage: 'Over <b>5 million</b> success stories',
  },
  units: {
    id: 'SignUp.bodyUnits',
    defaultMessage: 'Units',
  },
  accountflow_stats_intro_lose: {
    id: 'accountflow_stats_intro_lose',
    defaultMessage:
      'To help you <b>lose weight</b>, we need the following information to personalize your experience.',
  },
  accountflow_stats_intro_maintain: {
    id: 'accountflow_stats_intro_maintain',
    defaultMessage:
      'To help you <b>maintain weight</b>, we need the following information to personalize your experience.',
  },
  accountflow_stats_intro_gain: {
    id: 'accountflow_stats_intro_gain',
    defaultMessage:
      'To help you <b>gain weight</b>, we need the following information to personalize your experience.',
  },
  accountflow_goal_heading: {
    id: 'accountflow_goal_heading',
    defaultMessage: 'What’s your primary goal?',
  },
  accountflow_goal_intro: {
    id: 'accountflow_goal_intro',
    defaultMessage:
      'To help you become healthier, we need some basic information about you. Let’s get started!',
  },
  accountflow_method_heading: {
    id: 'accountflow_method_heading',
    defaultMessage: 'Choose signup method',
  },
  accountflow_account_intro: {
    id: 'accountflow_account_intro',
    defaultMessage:
      'Please add an email and password to be able to sign in to the app later on.',
  },
  accountflow_account_heading: {
    id: 'accountflow_account_heading',
    defaultMessage: 'Account information',
  },
  accountflow_subscription_intro: {
    id: 'accountflow_subscription_intro',
    defaultMessage:
      'All subscriptions give you full access to all of our features, including:',
  },
  pay_your_subscription: {
    id: 'pay_your_subscription',
    defaultMessage: 'Your subsciption',
  },
  cancel: {
    id: 'upgrade.cancel',
    defaultMessage: 'Cancel online at any time.',
  },
  cm: {
    id: 'SignUp.cm',
    defaultMessage: 'cm',
  },
  kg: {
    id: 'SignUp.kg',
    defaultMessage: 'kg',
  },
  ft: {
    id: 'SignUp.ft',
    defaultMessage: 'ft',
  },
  lbs: {
    id: 'SignUp.lbs',
    defaultMessage: 'lbs',
  },
  in: {
    id: 'SignUp.in',
    defaultMessage: 'in',
  },
  st: {
    id: 'SignUp.st',
    defaultMessage: 'st',
  },
  feet: {
    id: 'SignUp.feet',
    defaultMessage: 'Feet',
  },
  inches: {
    id: 'SignUp.inches',
    defaultMessage: 'Inches',
  },
  stones: {
    id: 'SignUp.stones',
    defaultMessage: 'Stones',
  },
  pounds: {
    id: 'SignUp.pounds',
    defaultMessage: 'Pounds',
  },
})
